// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import withSearchBarLoadTime from '../Timing/withSearchBarLoadTime';
import {media} from '../../utils/breakpoints';
import type {Breakpoint} from '../../utils/breakpoints';

import ExpandedSearchBar from '../ExpandedSearchBar/ExpandedSearchBar';
import MobileSearchBar from '../MobileSearchBar/MobileSearchBar';
import type {State as ReduxState} from '../../reducers/index';
import './SearchBar.less';

type StateProps = {
    breakpoint: Breakpoint
};

export type Props = StateProps;

export const SearchBar = ({breakpoint}: Props) => {
    return (
        <div className="SearchBar">
            {!media(breakpoint, {minWidth: 'SM_MIN'}) ? (
                <div className="SearchBar__mobile visible-xs-block">
                    <MobileSearchBar />
                </div>
            ) : (
                <div className="SearchBar__expanded hidden-xs">
                    <ExpandedSearchBar />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = ({viewport}: ReduxState): StateProps => ({
    breakpoint: viewport.breakpoint
});

export default compose(
    connect(mapStateToProps),
    withSearchBarLoadTime
)(SearchBar);
